// Native browser download from a direct server URL that streams with Content-Disposition.
// This is the most reliable path in installed PWA / Android TWA (uses the OS download
// manager) because it never touches blob: URLs. `url` must be same-origin & cookie-authed.
export function triggerDownload(url, filename) {
  const a = document.createElement("a");
  a.href = url;
  if (filename) a.download = filename;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// Robust cross-platform file download.
// Works on desktop browsers, mobile browsers, and installed PWA / Android TWA shells
// where the classic `<a download>` + immediate `revokeObjectURL` pattern silently fails.
export async function saveBlob(blob, filename, mime) {
  const type = mime || blob.type || "application/octet-stream";
  const isStandalone =
    typeof window !== "undefined" &&
    (window.matchMedia?.("(display-mode: standalone)")?.matches ||
      window.navigator.standalone === true);

  // Installed app shell (PWA/TWA/WebView): the download attribute is unreliable there,
  // so use the native share sheet ("Save to Files" / "Downloads" / print).
  if (isStandalone && typeof File !== "undefined" && navigator.canShare) {
    try {
      const file = new File([blob], filename, { type });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: filename });
        return;
      }
    } catch (e) {
      if (e && e.name === "AbortError") return; // user cancelled the share sheet
      // otherwise fall through to the anchor / new-tab fallbacks below
    }
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  if ("download" in a) {
    a.href = url;
    a.download = filename;
    a.rel = "noopener";
    a.style.display = "none";
    document.body.appendChild(a); // must be in the DOM for click() on some browsers
    a.click();
    a.remove();
  } else {
    // very old / restrictive WebView: open in a new tab so the OS viewer can save it
    window.open(url, "_blank");
  }
  // Defer revoke — revoking synchronously cancels the download on many browsers.
  setTimeout(() => URL.revokeObjectURL(url), 20000);
}
